export const AdminTypes = {
  admin: "admin",
  manager: "manager",
} as const;
